import { GetDocumentsByStudioFilter } from '@services/queries/documents/getDocumentsByStudio/getDocumentsByStudio.types';

export interface IDocumentsFilterCountParts {
  countSource: number;
  countMfr: number;
}

export function countDocumentsFilter(
  params: GetDocumentsByStudioFilter,
): [number, IDocumentsFilterCountParts] {
  const { manufacturerId = [], source } = params;

  const countSource = source ? 1 : 0;
  const countMfr = manufacturerId.length;

  const total = countSource + countMfr;
  const parts = { countSource, countMfr };
  return [total, parts];
}
